<template>
    <div class="card card-sticky">
        <div class="card-header">
            <h2>Stel je vraag</h2>
        </div>
        <div class="card-body">
            <p>Via het formulier kan je een vraag stellen.</p>
            <form @submit.prevent="submit" method="post">
                <div class="form-group" :class="{ 'has-invalid': $v.name.$error }">
                    <label for="name">Naam {{ $v.name.$error ? 'is verplicht' : '' }}</label>
                    <input type="text" name="name" id="name" class="form-control"
                           v-model.trim.lazy="$v.name.$model"
                           @focus="$v.name.$reset">
                </div>

                <div class="form-group" :class="{ 'has-invalid': $v.email.$error }">
                    <label for="email">E-mailadres {{ $v.email.$error ? 'is verplicht' : ''}}</label>
                    <input type="email" name="email" id="email" class="form-control"
                           v-model.trim.lazy="$v.email.$model"
                           @focus="$v.email.$reset">
                </div>

                <div class="form-group" :class="{ 'has-invalid': $v.message.$error }">
                    <label for="text">Vraag {{ $v.message.$error ? 'is verplicht' : '' }}</label>
                    <textarea name="message" id="text" rows="4" class="form-control"
                              v-model.trim.lazy="$v.message.$model"
                              @focus="$v.message.$reset"></textarea>
                </div>

                <button type="submit" class="btn btn-primary float-right">
                    <span>Versturen</span>
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import {email, required} from 'vuelidate/lib/validators';

export default {
    props: {
        route: String
    },
    data() {
        return {
            name: '',
            email: '',
            message: '',
        };
    },
    validations() {
        return {
            name: {
                required
            },
            email: {
                required,
                email,
            },
            message: {
                required,
            },
        };
    },
    methods: {
        submit() {
            this.$v.$touch();

            let that = this;

            if (!this.$v.$invalid) {
                this.axios.post(this.route, {
                    'name': this.name,
                    'email': this.email,
                    'message': this.message,
                })
                    .then(function (response) {
                        that.$notify({
                            group: 'base',
                            text: 'We hebben je vraag ontvangen en geven zo spoedig mogelijk antwoord.',
                            type: 'alert-info',
                        });

                        // clear form
                        that.name = '';
                        that.email = '';
                        that.message = '';

                        that.$v.$reset();
                    })
                    .catch(function (error) {
                        let msg = error.response.data.error || 'Er is iets fout gegaan, probeer het a.u.b. opnieuw.';

                        that.$notify({
                            group: 'base',
                            text: msg,
                            type: 'alert-danger',
                        });

                        that.$v.$touch();
                    })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/components/FaqForm.vue